import { render, staticRenderFns } from "./penambahan.vue?vue&type=template&id=8be374d2&"
import script from "./penambahan.vue?vue&type=script&lang=js&"
export * from "./penambahan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports